module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAKCAYAAABv7tTEAAAABHNCSVQICAgIfAhkiAAAAH9JREFUKJGVj0ERwkAQBHsBAZdfnpGChEiIAyzEASflJCABCUjAQfPZB0WlQm4+uzW1XbMDKbWod3Xhj0ItwA0YgBoRryPQM/e2c1eAR0S077equmbqptRZrb/mpDZ13gGvRzpvgfXUTQHnzpQJGHuAkp3LJY0VcIcZci4R8f4ArNhQGvH5t8MAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/returnBtn.png
// module id = 133
// module chunks = 0